import { useEffect, useState } from 'react';
import { useAuth } from '@frontegg/react';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const useCriticalAssetsNotificationBanner = (isCriticalAsset: boolean) => {
  const selectedEnvId = useSelectedEnv();
  const { user } = useAuth();

  const userMail = user?.email;
  const localStorageKey = `criticalAssetsNotificationBanner-${selectedEnvId}-${userMail}`;

  const localStorageValue = localStorage.getItem(localStorageKey);

  const [localStorageValueState, setLocalStorageValueState] = useState<
    string | null
  >(null);

  const setBannerVisibilityDefault = (value: boolean) => {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
    if (!value) setLocalStorageValueState('false');
  };

  useEffect(() => {
    setLocalStorageValueState(localStorageValue);
  }, [localStorageValue]);

  return {
    showBanner: localStorageValueState === 'false' ? false : isCriticalAsset,
    setShowNotificationsBanner: setBannerVisibilityDefault,
  };
};

export default useCriticalAssetsNotificationBanner;
